import PreloadLogo from "@assets/images/logo-baitulilmi.png";
import { BaseLayout } from "@components/generals/base_layout";
import { Header } from "@components/generals/header";
import { SchoolService } from "@services/school.service";
import { useSchoolStore } from "@stores/school.store";
import { useThemeStore } from "@stores/theme.store";
import { useQuery } from "@tanstack/react-query";
import { androidChangeThemeStatusBar } from "@utils/android";
import { useQueryURL } from "@utils/router";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

export const AuthPage = () => {
  const queryURL = useQueryURL();
  const { themeMode } = useThemeStore((state) => state);
  const { data: infoSchool } = useQuery(
    [SchoolService.queries.GET_SCHOOL_INFO],
    () => SchoolService.info()
  );
  const { name, updateInfo } = useSchoolStore((state) => state);

  const splitName = (name: string) => {
    if (!name) return { main: "Sistem Informasi Pondok", extra: "" };

    const match = name.match(/^(.+?)\s*(\(.+\))$/);

    return match
      ? { main: match[1], extra: match[2] }
      : { main: name, extra: "" };
  };
  const { main, extra } = splitName(
    name ?? "Baitul Ilmi (Islamic Boarding School)"
  );

  useEffect(() => {
    if (infoSchool) {
      updateInfo({
        name: infoSchool?.data?.namaSekolah,
        moto: infoSchool?.data?.moto,
      });
    }
  }, [infoSchool, updateInfo, queryURL]);

  useEffect(() => {
    if (themeMode === "light") {
      androidChangeThemeStatusBar("#1999FA", "dark");
    }

    if (themeMode === "dark") {
      androidChangeThemeStatusBar("#114C7D", "light");
    }
  }, [themeMode]);

  return (
    <BaseLayout>
      <Header classOverlay="tw-h-[180px]">
        <div className="page-title">
          <div className="tw-pt-24 text-center">
            <img
              className="tw-w-32 tw-h-32 tw-rounded-[15px] tw-bg-[#c5c5c582] tw-p-2 mb-3"
              src={PreloadLogo}
              alt="Rounded avatar"
              style={{
                backdropFilter: "blur(3px)",
              }}
            />
            <h2 className="mb-0">{main}</h2>
            <h3>{extra}</h3>
          </div>
        </div>
      </Header>
      <Outlet />
      {/* <Footer /> */}
    </BaseLayout>
  );
};
